import React from 'react';
import Typography from '../StyledTypography';
import Box from 'apollo-react/components/Box';
import Divider from 'apollo-react/components/Divider';
import { useTranslation } from 'react-i18next';
import CommentItem from './CommentItem';
import styles from './CommentViewer.module.css';

const CommentViewer = ({
  comments = [],
  compact = false,
  hideHeader = false,
  requestProgress,
  requestDateEnded,
  isAdditionalDocument = false,
  isSubformComment = false,
  isAssessmentReviewerComment = false,
  currentUserEmail,
  requestId,
  onCommentUpdated,
  onCommentDeleted,
}) => {
  const { t } = useTranslation();

  if (!comments?.length) {
    return null;
  }

  return (
    <Box className={`${styles.container} ${compact ? styles.compact : ''}`}>
      {!hideHeader && (
        <>
          <Typography variant="title2" className={styles.header}>
            {t('comments')}
          </Typography>
          <Divider className={styles.headerDivider} />
        </>
      )}

      {comments.map((item, index) => {
        // Normalize: FieldsComments wraps as item.comment, AdditionalDocumentsComments also wraps as item.comment
        // Direct Comment objects (e.g., from newly added) may not have wrapper
        const commentData = item.comment || item;
        return (
          <React.Fragment key={commentData.id || item.id || index}>
            <CommentItem
              comment={commentData}
              t={t}
              compact={compact}
              requestProgress={requestProgress}
              requestDateEnded={requestDateEnded}
              isAdditionalDocument={isAdditionalDocument}
              isSubformComment={isSubformComment}
              isAssessmentReviewerComment={isAssessmentReviewerComment}
              currentUserEmail={currentUserEmail}
              requestId={requestId}
              onCommentUpdated={onCommentUpdated}
              onCommentDeleted={onCommentDeleted}
            />
            {index < comments.length - 1 && (
              <Divider className={styles.divider} />
            )}
          </React.Fragment>
        );
      })}
    </Box>
  );
};

export default CommentViewer;
